import { render, staticRenderFns } from "./ProjectFundingAccountLabel.vue?vue&type=template&id=f715ce9a&scoped=true&"
import script from "./ProjectFundingAccountLabel.vue?vue&type=script&lang=ts&"
export * from "./ProjectFundingAccountLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f715ce9a",
  null
  
)

export default component.exports